import { useTranslation } from "@/hooks/localization/useTranslations";
import NextImage from "../../lib/NextImage";
import BaseOption from "./base-checkbox/BaseOption";
import OutOfStockSlash from "./OutOfStockSlash";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  image_src: string;
  disabled?: boolean;
  is_multi_select: boolean;
  label: string;
  isProductBox?: boolean;
  /** Sold out variant: stays visible, but is marked and (usually) not selectable. */
  outOfStock?: boolean;
  /** Sold out, yet still selectable so the shopper can request a restock reminder. */
  allowSelectOutOfStock?: boolean;
  /** Disabled by the backend — labelled "not available" instead of out of stock. */
  isDisabled?: boolean;
}

const ImageOption: React.FC<Props> = ({
  selected,
  toggleOption,
  image_src,
  label,
  disabled = false,
  is_multi_select,
  isProductBox,
  outOfStock,
  allowSelectOutOfStock,
  isDisabled,
}) => {
  const t = useTranslation();
  const selectable = !disabled || !!allowSelectOutOfStock;

  return (
    <div
      onClick={selectable ? toggleOption : undefined}
      aria-disabled={!selectable || undefined}
      className={`product-add-on ${selected ? "checked" : ""} ${
        outOfStock ? "out-of-stock" : ""
      }`}
      style={
        isProductBox
          ? {
              width: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 1,
              border: "1px solid",
              borderColor: !selected ? "var(--white)" : undefined,
              borderRadius: 10,
            }
          : undefined
      }
    >
      <div
        className="add-on-image"
        style={
          isProductBox
            ? { width: 16, height: 16, borderRadius: 10, position: "relative" }
            : { position: "relative" }
        }
      >
        <NextImage alt="" src={image_src} objectFit="fill" />
        {outOfStock && (
          <>
            {isProductBox && <OutOfStockSlash />}
            {!isProductBox && (
              <span className="add-on-out-of-stock-overlay">
                <span className="add-on-out-of-stock-label">
                  {isDisabled ? t.product_disabled : t.variant_out_of_stock}
                </span>
              </span>
            )}
          </>
        )}
      </div>
      {/* Card-wide diagonal: makes a sold-out card unmistakable at a glance. */}
      {outOfStock && !isProductBox && <OutOfStockSlash />}
      {!isProductBox && (
        <BaseOption
          disabled={disabled}
          selected={selected}
          toggleOption={toggleOption}
          is_multi_select={is_multi_select}
          label={label}
          allowSelectOutOfStock={allowSelectOutOfStock}
          muted={outOfStock}
        />
      )}
    </div>
  );
};

export default ImageOption;
